import { useTheme } from './ThemeContext';
import TOKENS from '../../theme/token-files/componentVariants';

export const ComponentVariants = () => {
  const { themeName } = useTheme();
  const componentVariants = themeName !== 'Vanilla' ? TOKENS[themeName] : TOKENS['DART'];

  return componentVariants;
};
